export default __webpack_public_path__ + "static/media/slider-efficiency.01dc04ad.png";